/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Firm } from '../../models/firm';

export interface GetFirms$Params {
}

export function getFirms(http: HttpClient, rootUrl: string, params?: GetFirms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Firm>>> {
  const rb = new RequestBuilder(rootUrl, getFirms.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Firm>>;
    })
  );
}

getFirms.PATH = '/api/firms';
